module.exports = __webpack_public_path__ + "static/media/ConferenceYear2017.d70f29db.png";